var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMapLocate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250 15C262.979 15 273.5 25.5214 273.5 38.5V63.4544C358.539 74.0588 425.942 141.46 436.545 226.5H461.5C474.479 226.5 485 237.021 485 250C485 262.979 474.479 273.5 461.5 273.5H436.545C425.942 358.539 358.539 425.942 273.5 436.545V461.5C273.5 474.479 262.979 485 250 485C237.021 485 226.5 474.479 226.5 461.5V436.545C141.46 425.942 74.0588 358.539 63.4544 273.5H38.5C25.5214 273.5 15 262.979 15 250C15 237.021 25.5214 226.5 38.5 226.5H63.4544C74.0588 141.46 141.46 74.0588 226.5 63.4544V38.5C226.5 25.5214 237.021 15 250 15ZM250 388.885C326.704 388.885 388.885 326.704 388.885 250C388.885 173.296 326.704 111.115 250 111.115C173.296 111.115 111.115 173.296 111.115 250C111.115 326.704 173.296 388.885 250 388.885Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336.01 250.353C336.01 298.049 297.344 336.715 249.647 336.715C201.951 336.715 163.285 298.049 163.285 250.353C163.285 202.656 201.951 163.99 249.647 163.99C297.344 163.99 336.01 202.656 336.01 250.353Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapLocate);
export default __webpack_public_path__ + "static/media/ico_map_locate.1e1bf4c76267cb4449b55ad0be6407b2.svg";
export { ForwardRef as ReactComponent };